import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GrupoFamiliar } from './grupo-familiar';
import { GrupoFamiliarService } from './grupo-familiar.service';
import { MatSnackBar } from '@angular/material';
import { ConfirmacaoDialog } from '../util/confirmacao.dialog';
import { Confirmacao } from '../util/confirmacao';
import { MatDialog } from '@angular/material';

@Component({
  templateUrl: './grupo-familiar-list.component.html',
	selector: 'grupo-familiar-list',
})
export class GrupoFamiliarListComponent implements OnInit {
    @Input()  ehAluno : boolean;
    @Input()  mostrarExcluir: boolean= true;
    @Input()  mostrarSalvar: boolean = true;
    @Input()  mostrarNovo: boolean = true;
    @Input()  idEstudo : number;
    @Input()  lista : GrupoFamiliar[];
    @Output() editarEmitido: EventEmitter<GrupoFamiliar> = new EventEmitter<GrupoFamiliar>();
    @Output() novoEmitido: EventEmitter<GrupoFamiliar> = new EventEmitter<GrupoFamiliar>();
    @Output() excluirEmitido: EventEmitter<GrupoFamiliar> = new EventEmitter<GrupoFamiliar>();


    public isLoading: boolean;


    constructor(private grupoFamiliarService: GrupoFamiliarService,
      private mensagem: MatSnackBar,
      public dialog: MatDialog)  {
    }

    ngOnInit() {
      if(this.idEstudo){
        this.buscar();
      }
    }

    buscar(){
      this.isLoading= true;
      let filtro: GrupoFamiliar = new GrupoFamiliar;
      filtro.codigoEstudoSocioEconomico = this.idEstudo;
      this.grupoFamiliarService.filtrar(filtro).subscribe(
        (result:GrupoFamiliar[]) => {
          this.lista = result;
          this.isLoading= false;
        },  error =>  this.erro(error)
      );
    }

    // Emite a row rowSelecionada
    public editar(event: GrupoFamiliar): void{
      this.editarEmitido.emit(event);
    }

    public novo(): void{
      this.novoEmitido.emit();
    }

    public excluir(event: GrupoFamiliar){
      let confirmacao: Confirmacao = new Confirmacao("Deseja excluir o registro: " + event.nomeMembro, false);
      let dialogRef = this.dialog.open(ConfirmacaoDialog, {
          width: '400px',
          data: confirmacao,
        });

        dialogRef.afterClosed().subscribe(result => {
          if(result){
            this.deletar(event);
          }
        });
    }


    private deletar(grupoFamiliar: GrupoFamiliar){
      this.isLoading = true;
      this.grupoFamiliarService.deletar(grupoFamiliar).subscribe(
        result => {
          this.mensagem.open("Registro excluído com sucesso!", 'X', {duration: 5000});
          this.excluirEmitido.emit(grupoFamiliar);
        },
        error =>  this.erro(error),
        () => this.finaliza()
      );
    }


    // mostra erros na tela
     private erro(erro: string): void{
         this.mensagem.open(erro, 'X', {duration: 5000});
         this.isLoading= false;
     }

     // finaliza o subscribe
     finaliza(): void{
       this.isLoading=false;
     }
}
